import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig.js";

const logUserAction = async (user, action, details = {}) => {
  if (!user || !user.uid) return;

  try {
    await addDoc(collection(db, "activityLogs"), {
      userId: user.uid, // ✅ ensure this is included
      userEmail: user.email,
      action,
      details,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error("Failed to log user action:", error);
  }
};

export default logUserAction;
